var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202,
    height: 248,
    viewBox: "0 0 202 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ebebeb;}.b{fill:#fff;stroke:#e3e3e3;}.c{fill:#041e41;}.d{fill:#676767;}.e{stroke:none;}.f{fill:none;}.g{filter:url(#c);}.h{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 28,
    y: 0,
    width: 174,
    height: 225,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 0,
    y: 23,
    width: 174,
    height: 225,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-92 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(129.092 322)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 4,
    rx: 2,
    transform: "translate(24.908 47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, -37.09, -6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(37 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 156,
    height: 207
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.5,
    y: 0.5,
    width: 155,
    height: 206
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 4,
    rx: 2,
    transform: "translate(24.908 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 4,
    rx: 2,
    transform: "translate(24.908 86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 5,
    rx: 2.5,
    transform: "translate(24.908 62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 5,
    rx: 2.5,
    transform: "translate(24.908 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 74,
    height: 4,
    rx: 2,
    transform: "translate(24.908 75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 4,
    rx: 2,
    transform: "translate(24.908 111)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 4,
    rx: 2,
    transform: "translate(24.908 123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M680.9,436.939,683,442.461a72.25,72.25,0,0,1,7.2-3.412q7.275-2.535,14.717-4.58a8.054,8.054,0,0,1,7.077,1.183c2.767,2.014,3.283,5.382.744,7.66A25.851,25.851,0,0,1,706.3,447.2a2.911,2.911,0,0,1-4.066-1.455,2.133,2.133,0,0,0-3.082-1.074c-2.215.892-4.173.842-5.906-1.163a2.416,2.416,0,0,0-2.331,0c-3.252,2.54-4.5,2.729-8.516.533-.42.57-.91,1.281-1.447,1.956-2.648,3.329-1.98,5.986,2.045,7.344,12.329,4.161,23.582,2.081,33.737-6.034a4.188,4.188,0,0,1,2.252-1.086,5.159,5.159,0,0,1-.706.9c-10.421,8.524-22.118,11.023-35.1,7.4-.279-.078-.548-.191-.821-.288-5.154-1.83-5.928-4.881-2.254-8.972.529-.59,1.162-1.087,1.824-1.7l-1.785-3.723c-.864,1.158-1.594,2.216-2.4,3.208-2.461,3.016-5.5,4.944-9.543,4.8-4.928-.177-7.464-4.241-5.317-8.653a60.434,60.434,0,0,1,3.366-5.365l-6.377.588c-.018-.168-.035-.335-.053-.5,1.815-.19,3.653-.262,5.436-.613a7.041,7.041,0,0,0,2.928-1.343c1.007-.8,1.688-2,2.66-2.858a7.987,7.987,0,0,1,2.743-1.668,2.728,2.728,0,0,1,3.5,1.429,2.469,2.469,0,0,1-1.044,3.567,20.743,20.743,0,0,1-6.2,1.579c-1.519.141-2.624.465-3.418,1.767-.678,1.112-1.5,2.146-2.1,3.294-1,1.9-1.362,3.889.157,5.709,1.555,1.861,3.659,2.925,5.986,2.144a14.358,14.358,0,0,0,5.089-3.067c1.449-1.357,2.378-3.262,3.574-4.9C679.6,438.317,680.178,437.753,680.9,436.939Zm2.886,6.117c2.48,2.2,3.782,2.228,5.766.437,2-1.808,3.308-2.081,4.938-.571a4.383,4.383,0,0,0,5.126.981c1.691-.663,3.258-.434,4.178,1.519a2.039,2.039,0,0,0,3.107.952,21.578,21.578,0,0,0,4.343-2.827,4.406,4.406,0,0,0-1.185-7.525,7.891,7.891,0,0,0-3.951-.9C698.109,435.918,690.915,439.022,683.783,443.056Zm-15.024-10.164.319.7a30.828,30.828,0,0,0,5.233-.983c.709-.253,1.308-1.482,1.47-2.358.106-.574-.577-1.782-1.055-1.866a3.367,3.367,0,0,0-2.5.713A42.65,42.65,0,0,0,668.759,432.892Z",
    transform: "translate(-611.273 -276.709)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101 344.824)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 5,
    rx: 2.5,
    transform: "translate(25 46.176)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, -9, -28.82)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(9 29)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 156,
    height: 207
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.5,
    y: 0.5,
    width: 155,
    height: 206
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 4,
    rx: 2,
    transform: "translate(25 50.176)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 4,
    rx: 2,
    transform: "translate(25 86.176)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 5,
    rx: 2.5,
    transform: "translate(25 62.176)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 5,
    rx: 2.5,
    transform: "translate(25 98.176)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 74,
    height: 5,
    rx: 2.5,
    transform: "translate(25 74.176)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 5,
    rx: 2.5,
    transform: "translate(25 110.176)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106,
    height: 4,
    rx: 2,
    transform: "translate(25 123.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M680.9,436.939,683,442.461a72.25,72.25,0,0,1,7.2-3.412q7.275-2.535,14.717-4.58a8.054,8.054,0,0,1,7.077,1.183c2.767,2.014,3.283,5.382.744,7.66A25.851,25.851,0,0,1,706.3,447.2a2.911,2.911,0,0,1-4.066-1.455,2.133,2.133,0,0,0-3.082-1.074c-2.215.892-4.173.842-5.906-1.163a2.416,2.416,0,0,0-2.331,0c-3.252,2.54-4.5,2.729-8.516.533-.42.57-.91,1.281-1.447,1.956-2.648,3.329-1.98,5.986,2.045,7.344,12.329,4.161,23.582,2.081,33.737-6.034a4.188,4.188,0,0,1,2.252-1.086,5.159,5.159,0,0,1-.706.9c-10.421,8.524-22.118,11.023-35.1,7.4-.279-.078-.548-.191-.821-.288-5.154-1.83-5.928-4.881-2.254-8.972.529-.59,1.162-1.087,1.824-1.7l-1.785-3.723c-.864,1.158-1.594,2.216-2.4,3.208-2.461,3.016-5.5,4.944-9.543,4.8-4.928-.177-7.464-4.241-5.317-8.653a60.434,60.434,0,0,1,3.366-5.365l-6.377.588c-.018-.168-.035-.335-.053-.5,1.815-.19,3.653-.262,5.436-.613a7.041,7.041,0,0,0,2.928-1.343c1.007-.8,1.688-2,2.66-2.858a7.987,7.987,0,0,1,2.743-1.668,2.728,2.728,0,0,1,3.5,1.429,2.469,2.469,0,0,1-1.044,3.567,20.743,20.743,0,0,1-6.2,1.579c-1.519.141-2.624.465-3.418,1.767-.678,1.112-1.5,2.146-2.1,3.294-1,1.9-1.362,3.889.157,5.709,1.555,1.861,3.659,2.925,5.986,2.144a14.358,14.358,0,0,0,5.089-3.067c1.449-1.357,2.378-3.262,3.574-4.9C679.6,438.317,680.178,437.753,680.9,436.939Zm2.886,6.117c2.48,2.2,3.782,2.228,5.766.437,2-1.808,3.308-2.081,4.938-.571a4.383,4.383,0,0,0,5.126.981c1.691-.663,3.258-.434,4.178,1.519a2.039,2.039,0,0,0,3.107.952,21.578,21.578,0,0,0,4.343-2.827,4.406,4.406,0,0,0-1.185-7.525,7.891,7.891,0,0,0-3.951-.9C698.109,435.918,690.915,439.022,683.783,443.056Zm-15.024-10.164.319.7a30.828,30.828,0,0,0,5.233-.983c.709-.253,1.308-1.482,1.47-2.358.106-.574-.577-1.782-1.055-1.866a3.367,3.367,0,0,0-2.5.713A42.65,42.65,0,0,0,668.759,432.892Z",
    transform: "translate(-611.273 -276.709)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignDoc);
export default __webpack_public_path__ + "static/media/signDoc.30609bb0411182466d143dc4b1ac204e.svg";
export { ForwardRef as ReactComponent };